import React, { forwardRef, memo, useCallback, useImperativeHandle, useRef, useState } from 'react';
import { func } from 'prop-types';
import { useDispatch } from 'react-redux';
import Websocket from 'react-websocket';

import { onPriceSocketChange } from 'Redux/tradeSocket';
import { useUserData } from '@services/users/me';

const { WEBSOCKET_PRICE } = process.env;

const PriceSocket = forwardRef((props, ref) => {
  const [isReady, setIsReady] = useState(false);
  const { onOpen } = props;

  const wsRef = useRef(null);

  const dispatch = useDispatch();

  const { userData } = useUserData();

  const subscribeStock = (code) => {
    if (!isReady) return;
    wsRef.current.sendMessage(
      JSON.stringify({
        id: userData?.id,
        method: 'SUBSCRIBE',
        stream: 'PRICE',
        streamObject: encodeURI(code),
      })
    );
  };

  const unsubscribeStock = (code) => {
    if (!isReady) return;
    wsRef.current.sendMessage(
      JSON.stringify({
        id: userData?.id,
        method: 'UNSUBSCRIBE',
        stream: 'PRICE',
        streamObject: encodeURI(code),
      })
    );
  };

  // Allow the following functions to be called by anyone that has access to this component ref
  // in this case is the parent component
  useImperativeHandle(ref, () => ({
    subscribeStock,
    unsubscribeStock,
  }));

  const handleMessage = useCallback((data) => {
    const parsedData = JSON.parse(data);
    dispatch(onPriceSocketChange(parsedData));
  }, []);

  if (userData && userData.id) {
    return (
      <Websocket
        url={WEBSOCKET_PRICE}
        ref={wsRef}
        onOpen={() => {
          setIsReady(true);
          onOpen();
        }}
        onClose={() => {
          setIsReady(false);
        }}
        reconnect={false}
        onMessage={handleMessage}
        debug={process.env.ENVIRONMENT === 'development'}
      />
    );
  }
  return null;
});

PriceSocket.propTypes = {
  onOpen: func,
};

PriceSocket.defaultProps = {
  onOpen: () => {},
};

export default memo(PriceSocket);
